import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import { pageTitle } from '../../helpers/PageTitle';
import { Link } from 'react-router-dom';

export default function Portfolio4() {
  pageTitle('Mwea - Solar Irrigation Project');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Solar-Powered Irrigation System"
        subTitle="Agricultural Project"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <div className="cs_portfolio_details">
          <img src="/images/portfolio/irrigation-1.jpg" alt="Irrigation System" />
          <Spacing lg="100" md="40" />
          <div className="cs_portfolio_details_in">
            <ul className="cs_portfolio_details_info cs_mp0">
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Client Type:</h3>
                <p className="mb-0">Agricultural Cooperative</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
                <p className="mb-0">Mwea, Kenya</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Duration:</h3>
                <p className="mb-0">6 Weeks</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">
                  Project Completed:
                </h3>
                <p className="mb-0">December 2023</p>
              </li>
            </ul>
            <div className="cs_portfolio_details_right">
              <h2>Project Summary</h2>
              <p>
                Implementation of a solar-powered irrigation system for rice farmers in Mwea, revolutionizing traditional farming practices. The system provides reliable water supply while significantly reducing operational costs.
                <br />
                This sustainable solution has improved crop yields and reduced dependency on seasonal rainfall patterns.
              </p>
              <p>
                System Features:
              </p>
              <ul>
                <li>Solar-powered water pumps</li>
                <li>Automated irrigation scheduling</li>
                <li>Weather monitoring integration</li>
                <li>Mobile app control system</li>
                <li>Water conservation features</li>
              </ul>
            </div>
          </div>
          <Spacing lg="115" md="60" />
          <div className="cs_portfolio_details_gallery">
            <div>
              <img src="/images/portfolio/irrigation-2.jpg" alt="Pump Station" />
            </div>
            <div>
              <img src="/images/portfolio/irrigation-3.jpg" alt="Field Coverage" />
            </div>
            <div>
              <img src="/images/portfolio/irrigation-4.jpg" alt="Control System" />
            </div>
          </div>
        </div>
        <Spacing lg="90" md="60" />
        <div className="cs_page_navigation cs_center">
          <div>
            <Link to="/portfolio/portfolio-3" className="cs_text_btn cs_type1">
              <Icon icon="cil:arrow-left" className="cs_fs_21" />
              <span>Prev Project</span>
            </Link>
          </div>
          <div>
            <Link to="/portfolio/portfolio-1" className="cs_text_btn">
              <span>Next Project</span>
              <Icon icon="cil:arrow-right" className="cs_fs_21" />
            </Link>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
    </>
  );
} 